export const PERMISSION_TIERS = {
  FULL_ACCESS: 'FULL_ACCESS',
  LIMITED_ACCESS: 'LIMITED_ACCESS',
};

export const getMasterMenuPermissionTier = ({
  cubohUser,
  companies,
  menu,
  singleSelectedCompanyID,
  isInternalUser = false,
}) => {
  if (!menu?.associatedMerchants || menu.associatedMerchants.length === 0) {
    return PERMISSION_TIERS.FULL_ACCESS;
  }

  if (isInternalUser) {
    return PERMISSION_TIERS.FULL_ACCESS;
  }

  if (cubohUser?.isParentCompanyUser) {
    return PERMISSION_TIERS.FULL_ACCESS;
  }

  const activeCompanies = Object.values(companies || {}).filter(company => company.active);
  const activeCompanyCount = activeCompanies.length;

  if (activeCompanyCount > 1) {
    return PERMISSION_TIERS.FULL_ACCESS;
  }

  const hasEnableMasterMenuFlag =
    cubohUser?.userDetails?.userMeta?.enableMasterMenu === true ||
    cubohUser?.userDetails?.userMeta?.enableMasterMenu === 'true';

  if (hasEnableMasterMenuFlag) {
    const menuCompanyId = menu?.companyId?.toString();
    const selectedCompanyId = singleSelectedCompanyID?.toString();

    if (menuCompanyId && selectedCompanyId && menuCompanyId === selectedCompanyId) {
      return PERMISSION_TIERS.FULL_ACCESS;
    }
  }

  return PERMISSION_TIERS.LIMITED_ACCESS;
};

export const canEditMasterMenuItems = tier => tier === PERMISSION_TIERS.FULL_ACCESS;

export const canEditLinkedMerchants = tier => tier === PERMISSION_TIERS.FULL_ACCESS;

export const canPublishMasterMenu = tier => tier === PERMISSION_TIERS.FULL_ACCESS;

export const canDeleteMasterMenu = tier => tier === PERMISSION_TIERS.FULL_ACCESS;

export const getMasterMenuDisabledTooltip = () =>
  'Master menus are not editable by company-level users';

export const getCloneMenuDisabledTooltip = itemTypePlural =>
  `You cannot edit master menu ${itemTypePlural} in cloned menus. Use master menu to edit.`;

export const getPosSyncDisabledTooltip = () =>
  "This menu is synced from your POS and can't be edited here";

/** Row-level variant: availability is the one field a POS-synced row still exposes, so the
 * blanket "can't be edited" copy would contradict the toggle sitting next to it. */
export const getPosSyncRowDisabledTooltip = (entity = 'item') =>
  `This ${entity} is synced from your POS. Only its availability can be changed here.`;
